var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import moment from 'moment';
import axios from '@didi/dajax';
import DialogCheckConfim from './dlg-check-confirm.vue';
export default Vue.extend({
    components: {
        'el-check-confirm': DialogCheckConfim,
    },
    props: {
        checkOrderId: {
            type: String,
            default: '',
            required: true,
        },
    },
    data: function () {
        return {
            pageSize: 20,
            pageNo: 1,
            totalItemCount: 0,
            downLoading: false,
            validDetailData: false,
            dialogConfirmVisiable: false,
            checkBalanceInfo: {},
            basicData: {},
            billList: [],
            border: false,
            basicConfig: [
                [
                    {
                        label: '对账单编号',
                        value: '',
                    },
                    {
                        label: '总保费',
                        value: '',
                    },
                    {
                        label: '本期费用条数',
                        value: '',
                    },
                ],
                [
                    {
                        label: '开票渠道',
                        value: '',
                    },
                    {
                        label: '推广费',
                        value: '',
                    },
                ],
                [
                    {
                        label: '申报日期',
                        value: '',
                    },
                    {
                        label: '账单截止日期',
                        value: '',
                    },
                ],
            ],
            tableConfig: [
                {
                    label: '流水号',
                    prop: 'billNo',
                    tooltip: true,
                    width: '220px',
                },
                {
                    label: '保单类型',
                    prop: 'orderTypeName',
                    tooltip: true,
                    width: '100px',
                },
                {
                    label: '签单日期',
                    prop: 'orderTime',
                    tooltip: true,
                    width: '128px',
                    formatter: function (val) {
                        return moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '保单号',
                    prop: 'policyNo',
                    tooltip: true,
                    width: '150px',
                },
                {
                    label: '批单号',
                    prop: 'endorseNo',
                    tooltip: true,
                    width: '150px',
                },
                {
                    label: '险种类别',
                    prop: 'policyTypeName',
                    tooltip: true,
                    width: '100px',
                },
                {
                    label: '对账渠道',
                    prop: 'channelName',
                    width: '150px',
                },
                {
                    label: '保险公司',
                    prop: 'insCompanyName',
                    width: '150px',
                },
                {
                    label: '投保城市',
                    prop: 'insuranceCityName',
                    width: '100px',
                },
                {
                    label: '保费',
                    prop: 'orderAmount',
                    width: '100px',
                },
                {
                    label: '税点',
                    prop: 'taxPoint',
                    width: '80px',
                },
                {
                    label: '剔除保费',
                    prop: 'afterTaxPremiumFee',
                    width: '100px',
                },
                {
                    label: '推广费比例',
                    prop: 'rate',
                    width: '102px',
                },
                {
                    label: '按比例推广费',
                    prop: 'rateAmount',
                    width: '116px',
                    formatter: function (val) {
                        return val;
                    },
                },
                {
                    label: '定额推广费',
                    prop: 'quotaAmount',
                    width: '102px',
                },
                {
                    label: '推广费总额',
                    prop: 'amount',
                    width: '102px',
                    formatter: function (val) {
                        return val;
                    },
                },
            ],
        };
    },
    methods: {
        shut: function () {
            this.dialogConfirmVisiable = false;
        },
        sizeChange: function (val) {
            this.pageSize = val;
            this.queryBillList();
        },
        currentChange: function (val) {
            this.pageNo = val;
            this.queryBillList();
        },
        launchSettleOrder: function () {
            this.checkBalanceInfo = __assign({}, this.basicData, { statementId: this.checkOrderId });
            this.dialogConfirmVisiable = true;
        },
        refreshPage: function () {
            this.queryCheckOrderDetail();
        },
        queryCheckOrderDetail: function () {
            var _this = this;
            var params = {
                statementId: this.checkOrderId,
            };
            return this.$request({
                url: '/proxy/carInsurance/channelBill/queryStatementDetail',
                method: 'post',
                data: params,
            })
                .then(function (res) {
                _this.queryBillList();
                if (!res) {
                    return;
                }
                if (res.errorCode) {
                    return;
                }
                _this.showPageDetailInfo(res.data);
            })
                .catch(function () {
                _this.queryBillList();
            });
        },
        queryBillList: function () {
            var _this = this;
            var params = {
                page: this.pageNo,
                pageSize: this.pageSize,
                statementId: this.checkOrderId,
            };
            this.$request({
                url: '/proxy/carInsurance/channelBill/queryStatementBillList',
                method: 'post',
                data: params,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode) {
                    return;
                }
                _this.pageNo = res.meta.current_page;
                _this.pageSize = res.meta.per_page;
                _this.totalItemCount = res.meta.total;
                _this.showBillList(res);
            });
        },
        showPageDetailInfo: function (data) {
            this.basicData.statementNo = data.statementNo;
            this.basicData.channelName = data.saleChannel.channelName;
            this.basicData.createAt = data.createdAt;
            this.basicData.sumOrderAmount = '￥' + data.sumOrderAmount;
            this.basicData.sumAmount = '￥' + data.sumAmount;
            this.basicData.endTime = moment(data.endTime).format('YYYY-MM-DD');
            this.basicData.sumBillNumber = data.sumBillNumber + '条';
            var _a = this.basicData, statementNo = _a.statementNo, channelName = _a.channelName, createAt = _a.createAt, sumOrderAmount = _a.sumOrderAmount, sumAmount = _a.sumAmount, endTime = _a.endTime, sumBillNumber = _a.sumBillNumber;
            this.basicConfig[0][0].value = statementNo;
            this.basicConfig[0][1].value = sumOrderAmount;
            this.basicConfig[0][2].value = sumBillNumber;
            this.basicConfig[1][0].value = channelName;
            this.basicConfig[1][1].value = sumAmount;
            this.basicConfig[2][0].value = createAt;
            this.basicConfig[2][1].value = endTime;
        },
        showBillList: function (res) {
            this.validDetailData = true;
            this.billList = res.data;
        },
        download: function () {
            return __awaiter(this, void 0, void 0, function () {
                var params;
                var _this = this;
                return __generator(this, function (_a) {
                    this.downLoading = true;
                    params = {
                        statementId: this.checkOrderId,
                    };
                    return [2 /*return*/, axios({
                            method: 'post',
                            url: '/proxy/carInsExport/channelBill/downloadStatement',
                            data: params,
                            needEncrypt: true,
                            responseType: 'blob',
                        })
                            .then(function (res) {
                            _this.downLoading = false;
                            var fileName = "\u5BF9\u8D26\u5355_" + _this.basicData.statementNo + ".xlsx";
                            _this.saveExportFile(fileName, res);
                            return res;
                        })
                            .catch(function () {
                            _this.downLoading = false;
                            _this.$message({
                                message: '对账单下载失败',
                                type: 'error',
                            });
                        })];
                });
            });
        },
        saveExportFile: function (fileName, response) {
            if (!response) {
                console.error('下载失败！');
            }
            var url = window.URL.createObjectURL(new Blob([response.data]));
            var link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        },
    },
    created: function () {
        this.refreshPage();
    },
});
